export const SMETA_TAB = 'SMETA_TAB';